<template>
    <div class="form-group mt-xl search guides-search has-icon">
        <input
            ref="input"
            type="text"
            aria-label="Sök guide"
            :placeholder="placeholder"
            autocomplete="off"
            class="input placeholder-shown has-icon-left"
        >
        <span class="icon-wrapper">
            <font-awesome-icon icon="search" class="text-sm" />
        </span>
    </div>
</template>

<script>
    import SearchAutocomplete from './SearchAutocomplete';

    export default {
        extends: SearchAutocomplete,
        data() {
            return {
                useHeaders: false,
            };
        },
        computed: {
            placeholder() {
                return window.translation('customer_service_hero_input_text');
            },
        },
        mounted() {
            this.setup();
        },
    };
</script>
